// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__QSOzK"};